import { Link } from 'react-router-dom';

export default function FinalCTA() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20warm%20abstract%20background%20with%20gentle%20golden%20and%20cream%20tones%20subtle%20texture%20elegant%20minimal%20design%20blurred%20organic%20shapes%20serene%20atmosphere%20soothing%20professional%20aesthetic&width=1920&height=600&seq=cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-foreground-950/75" />
      </div>

      <div className="relative z-10 max-w-[800px] mx-auto px-4 md:px-6 lg:px-10 text-center">
        <h2 className="font-heading text-accent-100 text-2xl md:text-3xl lg:text-4xl mb-5">
          Your Next Move Starts With a Simple Conversation
        </h2>
        <p className="text-background-100/80 font-body text-base md:text-lg leading-relaxed max-w-[600px] mx-auto mb-8">
          Whether you are ready to sell now or are only beginning to explore
          your options, Carol can help you understand the market, your
          property's potential value and the steps involved.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/home-valuation"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-8 py-3.5 rounded-md text-base font-body font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-200"
          >
            <i className="ri-home-4-line text-lg" />
            Request a Free Home Valuation
          </Link>
          <Link
            to="/contact"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border-2 border-accent-300 text-accent-100 px-8 py-3.5 rounded-md text-base font-body font-semibold whitespace-nowrap hover:bg-accent-300/10 transition-all duration-200"
          >
            <i className="ri-chat-3-line text-lg" />
            Contact Carol
          </Link>
        </div>
      </div>
    </section>
  );
}